<div style="display: flex; margin-top: 24px">
  <!-- Conversation View -->
  <div class="right_bar" style="flex: 8">
    <div class="ui basic segment" style="margin: 0; border: 0; padding: 0">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
